import { defineMessages } from 'react-intl';

export default defineMessages({
    account: {
        id: 'header.links.Account',
        defaultMessage: 'Account'
    },
    faq: {
        id: 'header.links.FAQ',
        defaultMessage: 'FAQ'
    },
    editProfile: {
        id: 'ri.header.links.Edit Profile',
        defaultMessage: 'Edit Profile'
    },
    changePassword: {
        id: 'ri.header.links.Change Password',
        defaultMessage: 'Change Password'
    },
    myNotification: { // FB 14847
        id: 'ri.header.links.Go Paperless!',
        defaultMessage: 'Go Paperless!'
    },
    logout: {
        id: 'header.links.Logout',
        defaultMessage: 'Logout'
    }
});
